import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

import * as Dialog from '@radix-ui/react-dialog';
import X from '@splashthat/doppler/icons/X';

import DoNotSellBanner, { StyledButton } from './DoNotSellBanner';

const overlayShow = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const contentShow = keyframes`
    from {
        opacity: 0;
        transform: translate(-50%, -48%) scale(0.96);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1);
    }
`;

/* eslint-disable @splashthat/sui-colors-only */
const DialogOverlay = styled(Dialog.Overlay)`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    z-index: 9999;
    animation: ${overlayShow} 200ms cubic-bezier(0.16, 1, 0.3, 1);
`;

const DialogContentWrapper = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 10000;
    transform: translate(-50%, -50%);
    animation: ${contentShow} 200ms cubic-bezier(0.16, 1, 0.3, 1);
`;

const IconButton = styled(StyledButton)`
    border: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;

    position: absolute;
    top: 1rem;
    right: 1.5rem;
`;

const GuestDoNotSellModal = ({ trigger, open = false, onOpenChange, ...props }) => {
    const titleId = React.useId();
    const descriptionId = React.useId();

    return (
        <Dialog.Root open={open} onOpenChange={onOpenChange}>
            <Dialog.Trigger asChild>{trigger}</Dialog.Trigger>
            <Dialog.Portal>
                <DialogOverlay />
                <Dialog.Content asChild aria-labelledby={titleId} aria-describedby={descriptionId}>
                    <DialogContentWrapper>
                        <DoNotSellBanner
                            {...props}
                            onCancel={() => onOpenChange(false)}
                            onConfirm={() => onOpenChange(false)}
                            titleId={titleId}
                            descriptionId={descriptionId}
                        />
                        <Dialog.Close asChild>
                            <IconButton type="button" aria-label="Close">
                                <X />
                            </IconButton>
                        </Dialog.Close>
                    </DialogContentWrapper>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

GuestDoNotSellModal.propTypes = {
    trigger: PropTypes.node.isRequired,
    open: PropTypes.bool,
    onOpenChange: PropTypes.func,
};

GuestDoNotSellModal.defaultProps = {
    open: false,
    onOpenChange: () => {},
};

export default GuestDoNotSellModal;
